// src/CustomerDetails.js
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { products } from "./salesmanHelpers";
import "./BillingSystem.css";

export default function CustomerDetails() {
  const navigate = useNavigate();
  const [customer, setCustomer] = useState(null);

  useEffect(() => {
    const saved = localStorage.getItem("selectedCustomer");
    if (saved) setCustomer(JSON.parse(saved));
  }, []);

  const handlePrint = () => {
    window.print();
  };

  if (!customer) {
    return (
      <div>
        <h2>No customer selected</h2>
        <button onClick={() => navigate(-1)}>⬅ Back</button>
      </div>
    );
  }

  const totalUnits = customer.totals.reduce((a, b) => a + b, 0);
  const totalSchemes = customer.schemes.reduce((a, b) => a + b, 0);

  return (
    <div style={{ padding: "20px" }}>
      <h2>Customer Details</h2>
      <p><strong>Name:</strong> {customer.name}</p>
      <p><strong>Phone:</strong> {customer.phone}</p>
      <p><strong>Route:</strong> {customer.route}</p>

      <h3>Products (Carton / Scheme)</h3>
      <table border="1" cellPadding="5" style={{ borderCollapse: "collapse", width: "100%" }}>
        <thead>
          <tr>
            <th>Product</th>
            <th>Cartons</th>
            <th>Scheme</th>
          </tr>
        </thead>
        <tbody>
          {products.map((p, i) => (
            <tr key={i}>
              <td>{p}</td>
              <td>{customer.totals[i] || ""}</td>
              <td>{customer.schemes[i] || ""}</td>
            </tr>
          ))}
        </tbody>
      </table>

      <h3>Summary</h3>
      <p><strong>Total Units (Cartons only):</strong> {totalUnits}</p>
      <p><strong>Total Schemes:</strong> {totalSchemes}</p>

      <button onClick={handlePrint} style={{ marginRight: "10px" }}>🖨 Print</button>
      <button onClick={() => navigate(-1)}>⬅ Back</button>
    </div>
  );
}
